export default function (
  appName: string,
  to: {
    name: string
    params?: Record<string, string>
    query?: Record<string, string>
  },
) {
  const { $i18n } = useNuxtApp()
  const {
    public: { externalApps },
  } = useRuntimeConfig()
  const app = externalApps?.[appName]

  if (!app) {
    throw new Error(`App ${appName} not found in runtimeConfig.public.externalApps`)
  }

  const appBaseUrl = app.baseUrl?.endsWith('/') ? app.baseUrl : `${app.baseUrl}/`

  const externalUrlData = btoa(
    JSON.stringify({
      ...to,
      locale: $i18n.locale.value,
    }),
  )

  return `${appBaseUrl}?externalUrlData=${externalUrlData}`
}
